import moment from 'moment'

export const formatDate = date => {
  return `${moment(date).format('MMMM Do').slice(0, -2).toUpperCase()}${moment(date).format('MMMM Do').slice(-2)}`
}

export const formatDateTime = (date): string => {
  if (!date) return ''

  return moment(date).format('LLL')
}
